import React, { useEffect, useState, useMemo } from 'react';
import ReactModal from 'react-modal';

import '../styles/statusBar.css';
import { getStepFromStatus } from '../utils/Miscellaneous';
import TransactionDetailBox from './TransactionDetailBox';
import SubscriptionComponent from './SubscriptionComponent';
import useFetchTransactionDetails from '../hooks/useFetchTransactionDetails';

const TransactionStatusPage = ({ messageGroupId, documentType, referenceIdentifier }) => {
    const { fetchTransactions, transactionDetails, transactionsLoading, transactionsError } = useFetchTransactionDetails();
    const [lastFetchedId, setLastFetchedId] = useState(null);
    const [isSubscribeModalOpen, setLaunchSubscribeModal] = useState(false);
    const [isUnSubscribeModalOpen, setLaunchUnSubscribeModal] = useState(false);
    const [subscriptionTransaction, setSubscriptionTransaction] = useState(null);

    useEffect(() => {
        if (messageGroupId && messageGroupId !== lastFetchedId) {
            setLastFetchedId(messageGroupId);
            console.log("Fetching transactions with:", {
                referenceIdentifier,
                messageGroupId,
                documentType
            });
            
            const fetchTransaction = async () => {
                await fetchTransactions(null, referenceIdentifier, messageGroupId, documentType);
            };
            fetchTransaction();
        }
    }, [messageGroupId, documentType, referenceIdentifier, lastFetchedId, fetchTransactions]);  
    
    // Memoize transactionArray to avoid recalculating on every render
    const transactionArray = useMemo(() => {
        return transactionDetails?.transactionList?.transaction
            ? Array.isArray(transactionDetails.transactionList.transaction)
                ? transactionDetails.transactionList.transaction
                : [transactionDetails.transactionList.transaction]
            : [];
    }, [transactionDetails]);

    // Memoize the sorted transactions to prevent unnecessary recalculations
    const sortedTransactions = useMemo(() => {
        return transactionArray
            .filter(transaction => getStepFromStatus(transaction.boomiStatus) !== "Received")
            .sort((a, b) => {
                const statusPriority = {
                    'Received': 1,
                    'Processing': 2,
                    'Sent': 3,
                    'Received-Error': 1,
                    'Translated-Error': 2,
                    'Sent-Error': 3
                };

                const statusA = statusPriority[getStepFromStatus(a.boomiStatus)] || 99;
                const statusB = statusPriority[getStepFromStatus(b.boomiStatus)] || 99;

                // First, sort by status priority
                if (statusA !== statusB) {
                    return statusA - statusB;
                }

                // If status is the same, sort by date
                return new Date(b.dateTime) - new Date(a.dateTime);
            });
    }, [transactionArray]);

    // Set the latest transaction that is not "Received"
    useEffect(() => {
        if (sortedTransactions.length > 0) {
            const sentTransaction = sortedTransactions.find(transaction => getStepFromStatus(transaction.boomiStatus) === "Sent");
            const processedTransaction = sortedTransactions.find(transaction => getStepFromStatus(transaction.boomiStatus) === "Processing");

            setSubscriptionTransaction(sentTransaction || processedTransaction || sortedTransactions[0]);
        }
    }, [sortedTransactions]);

    const handleSubscribe = () => setLaunchSubscribeModal(true);
    const handleUnSubscribe = () => setLaunchUnSubscribeModal(true);

    // Render loading, error, or no transactions before showing the transaction list
    if (transactionsLoading) {
        return <div>Loading...</div>;
    }

    if (transactionsError) {
        return <div>Error: {transactionsError}</div>;
    }

    if (!transactionDetails || !transactionDetails.transactionList) {
        return <div>No transaction found</div>;
    };

    console.log("subscription transactio", subscriptionTransaction);

    return (
        <div>
            {subscriptionTransaction ? (
                <div className="button-container">
                    <button className="subscribe-button" onClick={handleSubscribe}>
                        Subscribe
                    </button>
                    <button className="unsubscribe-button" onClick={handleUnSubscribe}>
                        Unsubscribe
                    </button>
                </div>
            ) : (
                <div style={{ color: 'red', fontWeight: 'bold' }}>
                    Disclaimer: Subscriptions are not available for flows with only received transactions.
                </div>
            )}

            <div className="transaction-status-page">
                <TransactionDetailBox transactions={transactionArray} />
            </div>

            {/* Modal for subscription */}
            <ReactModal
                isOpen={isSubscribeModalOpen}
                contentLabel="Transaction Subscription"
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => setLaunchSubscribeModal(false)}
            >
                {subscriptionTransaction ? (
                    <SubscriptionComponent transaction={subscriptionTransaction} actionType={"SUBSCRIBE"} />
                ) : (
                    <p>Details not available for subscription to be processed</p>
                )}
                <button onClick={() => setLaunchSubscribeModal(false)} className='close-button'>Close</button>
            </ReactModal>

            {/* Modal for unsubscription */}
            <ReactModal
                isOpen={isUnSubscribeModalOpen}
                contentLabel="Transaction Unsubscription"
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => setLaunchUnSubscribeModal(false)}
            >
                {subscriptionTransaction ? (
                    <SubscriptionComponent transaction={subscriptionTransaction} actionType={"UNSUBSCRIBE"} />
                ) : (
                    <p>Details not available for un-subscription to be processed</p>
                )}
                <button onClick={() => setLaunchUnSubscribeModal(false)} className='close-button'>Close</button>
            </ReactModal>
        </div>
    );
};

export default TransactionStatusPage;
